export default "data:application/octet-stream;base64,aW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JwoKY29uc3QgQ29ubmVjdGVkU291cmNlRmFjZWJvb2tMZWFkcyA9ICgpID0+IHt9Cg=="